import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=339da508"
import script from "./StudentList.ts?vue&type=script&lang=ts&external"
export * from "./StudentList.ts?vue&type=script&lang=ts&external"
import style0 from "./StudentList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports